export default "__VITE_ASSET__DTnjRGS___"